import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { HttpService } from 'src/app/core/http/http.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import html2pdf from 'html2pdf.js';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'canva',
    templateUrl: './canva.component.html',
    styleUrls: ['./canva.component.scss']    
}) 
export class CanvaComponent implements OnInit{

    @ViewChild('canvaContent', { static: true, read: ViewContainerRef }) contentEl: HTMLElement;
    @HostListener('window:resize', ['$event']) onResize(event) {
        this.modelResize();
    }
    print = false;

    form:FormGroup;

    wrapperStyle:any = {};  
    params:any = {};  
    qrCodeLink:any = ''; 
    printMessage = ''; 

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialog: MatDialog,
        private elementRef: ElementRef,
        protected httpService: HttpService,
        protected gs: GeneralService,
        protected formBuilder: FormBuilder
    ){
    }

    ngOnInit(){
        this.params = this.data.data || {};
        
        let group = {};
        Object.entries(this.params.fields).map((item:any) => {
            group[item[0]] = [item[1].value];
        });

        this.form = this.formBuilder.group(group);

        this.form.valueChanges.subscribe(result => {
            this.updateVariables(result);
        });
        this.updateVariables(this.form.value);

        this.default();
    }

    default(){
        this.modelResize();    
    }
    
    modelResize(){
        let pixel = 0.026458; // cm in px
        let widthInCM = 112; // in cm
        let heightInCM = 60; // in cm
        let width = widthInCM / pixel;
        let height = heightInCM / pixel;
        let screenWidth = window.innerWidth;
        let screenHeight = window.innerHeight;
        let marginW = 270; // in px
        let marginH = 350; // in px
        let maxW = 0.8;
        let maxH = 0.65;
        let zoom = 1;
        if(width+marginW > screenWidth * maxW){
            zoom = ((screenWidth * maxW) / (width+marginW));
        }
        if(height+marginH > screenHeight * maxH){
            let zoomH = ((screenHeight * maxH) / (height+marginH));

            if(zoomH < zoom)
                zoom = zoomH;
        }
        
        this.wrapperStyle = {zoom:zoom};

    }

    closeModal(result = null){
        this.dialog.getDialogById(this.data.modalId).close(result);
    }

    updateVariables(data){
        Object.entries(data).map(item => {
            if(item[0].toLowerCase().indexOf('color') > -1){
                this.elementRef.nativeElement.closest('body').style.setProperty('--'+item[0], item[1]);
            }

            if(item[0] == 'qrCodeLink')
                this.qrCodeLink = item[1];
        });
    }

    pdf(event){
        this.print = true;
        this.printMessage = 'Aguarde, gerando o PDF';

        setTimeout(()=>{

            this.createPDF(document.getElementById('canvaContent'), {
                unit : 'cm',
                format : [112, 60],
                orientation: 'landscape'
            }).then(result => {
                this.printMessage = 'Pronto! Salvando arquivo';
                console.log(result);
            })
            .finally(() => setTimeout(() => { this.print = false; this.printMessage=''; }, 1000));

        },300);

    }

    save(event){
        this.closeModal(this.form.dirty? this.form.value : false);
    }

    async createPDF(contentEL, options:any = {}, callback = null): Promise<any> {
       
        
        var th = this;

        const config = {
            filename: this.params.filename || 'file.pdf',
            image:        { 
                type: 'jpeg', 
                quality: 0.98 
            },
            html2canvas: {
                dpi: 192, 
                letterRendering: true,
                scale: 2,
                scrollX: 0,
                scrollY: 0,
                allowTaint: true,
                useCORS: true,
                onclone: function(element){
                    const svgElements = Array.from(element.querySelectorAll('svg'));
                    svgElements.forEach(function(s:any){
                        const bBox = s.getBBox();
                        const sizes = th.svgCalculateSize(s);

                        s.setAttribute("x", bBox.x);
                        s.setAttribute("y", bBox.y);

                        if(!isNaN(sizes.width))
                            s.setAttribute("width", sizes.width);
                        if(!isNaN(sizes.height))
                            s.setAttribute("height", sizes.height);
                    });
                }
            },
            jsPDF: { 
            unit: options?.unit || 'mm',
            format: options?.format || 'a4', 
            orientation: options?.orientation || 'portrait'
            }
        };

        let file = await this.printPDF(contentEL, config);


        console.log(file);
        return;

        //await this.uploadPDF(file, data?.owner, data?.authorization?.person_request_id, callback);
            
    }

    
    svgCalculateSize = function (el) {
        var heightComponents = ['height', 'paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth'],
            widthComponents = ['width', 'paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth'];
        
        var gCS = window.getComputedStyle(el), // using gCS because IE8- has no support for svg anyway
            bounds = {
                width: 0,
                height: 0
            };

        heightComponents.forEach(function (css) { 
            bounds.height += parseFloat(gCS[css]);
        });
        widthComponents.forEach(function (css) {
            bounds.width += parseFloat(gCS[css]);
        });
        return bounds;
    };

    printPDF(content: any, config: any) {
        return html2pdf()
            .set(config)
            .from(content)
            .toPdf()
            .save();
            //.outputPdf('blob');
    }

    async uploadPDF(body, person_id, authorization_id, callback){
/*
        this.pdfSubscription = this.fileUpload.getFilesChangeSubscription().subscribe(async result => {
            if(result && typeof result[0] !== 'undefined'){
                callback(result[0]);
                this.fileUpload.setCallback(null);
                this.pdfSubscription?.unsubscribe();
            }
        });

        this.fileUpload.setDefault();
        this.fileUpload.origin = 'person';
        this.fileUpload.ref = authorization_id;
        this.fileUpload.gallery = 'private.person.authorization';
        this.fileUpload.ownerId = person_id;
    
        this.fileUpload.fileEvent(
          [{
            name: 'Autorização.pdf',
            type: body.type,
            size: body.size,
            body: body
          }]);
          */
    }
 
}
